import { PropsWithChildren } from "react";
import { ICellRendererParams } from "ag-grid-community";
import classNames from "classnames";

import { Checkbox } from "components/Checkbox/Checkbox";

import styles from "./styles.module.scss";

export interface ColsData {
  isConducted: boolean | -1;
  number: number;
  action: string;
  string: string;
  creationTime: string;
  stock: string;
  provider: string;
  client: string;
  comment: string;
  sum: number;
  receivingStock: string;
  amountSales: number;
  available: boolean;
}

interface ContainerProps {
  available: boolean;
  className?: string;
}

const Container = ({
  children,
  available,
  className,
}: ContainerProps & PropsWithChildren): JSX.Element => (
  <div className={classNames(className, { "text-purple-500": available })}>
    {children}
  </div>
);

export const RowRender = (
  row: ICellRendererParams<ColsData>
): JSX.Element | null => {
  switch (row.colDef?.field) {
    case "number":
      return (
        <Container available={!!row.data?.available}>
          <span>{row.data?.number}</span>
        </Container>
      );
    case "isConducted":
      return (
        <Container
          available={!!row.data?.isConducted}
          className={styles.checkbox}
        >
          {row.data?.isConducted !== -1 && (
            <Checkbox
              width={16}
              height={16}
              wrapperHeight={40}
              checked={row.data?.isConducted}
              disabled
            />
          )}
        </Container>
      );
    case "string":
      return (
        <Container available={!!row.data?.available}>
          <Checkbox
            width={16}
            height={16}
            wrapperHeight={40}
            checked={row.data?.available}
          />
        </Container>
      );
    case "action":
      return (
        <Container available={!!row.data?.available}>
          <span>{row.data?.action}</span>
        </Container>
      );
    default:
      return <span>{row.data?.[row?.colDef?.field || "string"]}</span>;
  }
};
